const extractDataOnlineSalesPartyAvailabilityList = (data = []) => data


const extractDataOnlineSalesPartyAvailabilityDetail = () => { }


export {
  extractDataOnlineSalesPartyAvailabilityList,
  extractDataOnlineSalesPartyAvailabilityDetail
}